import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-n', 'LetterN', [["path",{"d":"M8 17V7l7.5 10V7","key":"svg-0"}]]);